// extracted by mini-css-extract-plugin
export default {"card":"right-card_card__qb9HF"};